<template>
  <div class="activate-table-input-component">
    <input
      v-bind="elAttribute"
      :class="['border-0 border-b outline-hidden border-[#84868B] placeholder-[#84868B] bg-transparent w-full', stylingClasses, {'border-black': (!placeholder || value)}]"
      v-model="inputValue"
      :placeholder="placeholder"
      @focus="onFocus"
      @blur="onBlur"
      @change="onChange"
      @keydown.enter="onEnter"/>
  </div>
</template>

<script src="./table-column-input.js"></script>
